<!-- 驿站维护 stationMaintenance -->
<template>
  <div>
    <x-tabula
      ref="table"
      :dataSource="dataSource"
      rowKey="postId"
      :searchList="searchList"
      :columns="columns"
      :tableOptList="tableOptList"
      :rowOptLen="4"
      :rowOptList="rowOptList"
      :searchParams.sync="searchParams"
      :deleteParam="deleteParam"
      :listApi="listApi"
      @resetSearch = "resetSearch"
    >
      <template slot="opt_status" slot-scope="{row}">
        <div style="display: flex; align-items: center">
          <span class="circle-dot" :class="activityColor[row.status]"></span>
          <span>{{ row.statusDesc }}</span>
        </div>
      </template>
    </x-tabula>

    <!---->
    <a-modal
      width="1010px"
      :title="modalTitle"
      :visible="visible"
      @ok="addLeader"
      @cancel="closeModel"
      :confirmLoading="btnLoading.loading"
      v-bind="this.$store.state.modalConfig"
    >
    <x-addEdit
      ref="form"
      :formList="formList"
      :formKey="formKey"
      :addParam="addParam"
      :editParam="editParam"
      :detailParam="detailParam"
      :defaultCheckedKeys="defaultCheckedKeys"
      :isSubmitBtn="false"
    >
      <template slot="gps" slot-scope="{formItem}">
        <x-location
          ref="location"
          :form="$children[0].form"
          :inputKey="inputKey"
          :position="position"
          :lngLat="lngLat"
          @transferValue="transferValue"
          :locationData="formItem">
        </x-location>
      </template>
    </x-addEdit>
    </a-modal>
  </div>
</template>

<script>
import {fetchSelect} from '@/utils/mixins';
export default {
  name: 'stationMaintenance',
  mixins: [fetchSelect],
  data () {
    let decoratorOptions = {
      mapLng: {
        validateTrigger: 'blur',
        rules: [{required: true, message: '输入经度'}]
      },
      mapLat: {
        validateTrigger: 'blur',
        rules: [{required: true, message: '输入纬度'}]
      }
    };
    return {
      newAreas: undefined,
      inputKey: {
        lng: 'mapLng',
        lat: 'mapLat',
        address: 'address'
      },
      mapLng: undefined,
      mapLat: undefined,
      position: '',
      lngLat: [],
      activityColor: [
        'info-bg',
        'success-bg',
        'info-bg',
        'info-bg',
        'info-bg'
      ],
      modalTitle: '添加',
      visible: false,
      defaultCheckedKeys: [],
      btnLoading: { loading: false },
      // 表单参数
      addParam: {
        url: '/housekeep/post/add',
        reqHandle: this.reqHandle,
        resHandle: this.addResHandle
      },
      editParam: {
        url: '/housekeep/post/',
        pathParam: true,
        resHandle: this.addResHandle
      },
      detailParam: {
        url: '/housekeep/post/',
        resHandle: this.detailResHandle
      },
      formKey: {
        roleName: ''

      },
      formList: [
        {
          label: '名称',
          inputType: 'input',
          options: [],
          placeholder: '请输入站点名称',
          props: ['postName', {
            rules: [
              { required: true, message: '请输入站点名称' }
            ]
          }]
        },
        {
          label: '所在地区',
          inputType: 'cascader',
          options: [],
          placeholder: '请选择所在地区',
          handle: this.regionChange,
          displayRender: this.regionDisplayRender,
          expandTrigger: 'click',
          loadData: e => {
            this.newRegionSelect(1, 'formList', '1,2,3', e);
          },
          props: ['areas', {
            rules: [
              {required: true, message: '请选择所在地区'}
            ]
          }]
        },
        {
          label: '详细地址',
          inputType: 'input',
          options: [],
          placeholder: '请输入详细地址',
          props: ['address', {
            rules: [
              { required: true, message: '请输入详细地址' }
            ]
          }]
        },
        {
          slot: 'gps',
          label: 'GPS定位',
          inputType: 'input',
          subList: [
            {
              inputType: 'input',
              placeholder: '经度',
              props: ['mapLng', decoratorOptions.mapLng]
            },
            {
              inputType: 'input',
              placeholder: '纬度',
              props: ['mapLat', decoratorOptions.mapLat]
            }
          ]
        },
        {
          label: '绑定小区',
          inputType: 'select',
          mode: 'multiple',
          options: [],
          placeholder: '请选择',
          fetchOptions: this.getflOptions,
          props: ['communityId', {
            rules: [
              { required: false, message: '' }
            ]
          }]
        }

      ],
      searchList: [
        { props: ['postName'], placeholder: '名称', options: [], inputType: 'input' },
        { props: ['communityId'], placeholder: '绑定小区', options: [], inputType: 'select', fetchOptions: this.getOptions },
        {
          props: ['status'],
          placeholder: '状态',
          options: [
            {label: '启用', value: 1},
            {label: '禁用', value: 0}
          ],
          inputType: 'select'
        }
      ],
      tableOptList: [
        { text: '新增', icon: 'plus', handle: this.openModal, permi: ['community:housekeepPost:add'] },
        { text: '删除', icon: 'close', disabled: true, permi: ['community:housekeepPost:remove'] }
      ],
      rowOptList: [
        { text: '修改', handle: (row) => this.openModal(row), permi: ['community:housekeepPost:edit'] },
        {
          text: '',
          handle: row => this.changeStatus(row),
          customRender: true,
          rowOptText: row => row.status === 1 ? '停用' : '启用',
          permi: ['community:housekeepPost:editStatus']
        }
      ],
      columns: [
        { title: '所在地区', dataIndex: 'area', align: 'left', width: '120px' },
        { title: '驿站名称', dataIndex: 'postName', align: 'left', width: '' },
        { title: '地址', dataIndex: 'address', align: 'left', width: '' },
        { title: '绑定小区', dataIndex: 'communityName', align: 'left', width: '' },
        { title: '状态', dataIndex: 'statusDesc', align: 'left', width: '80px', scopedSlots: { customRender: 'status' }},
        { title: '操作', dataIndex: 'action', align: 'left', width: '120px', scopedSlots: {customRender: 'action'} }
      ],
      dataSource: [],
      searchParams: {
        postName: undefined,
        communityId: undefined,
        status: undefined
      },
      listApi: {
        url: '/housekeep/post/list',
        resHandle: '', // this.resHandle
        searchHandle: '' // searchHandle
      },
      deleteParam: {
        url: '/housekeep/post/',
        param: {},
        title: '驿站',
        key: 'postName'
      }
    };
  },
  created () {
    this.newRegionSelect(1, 'formList', '1,2,3');
  },
  mounted () {
    this.getSelect();
  },
  methods: {
    resetSearch () {
      this.communitySelectByStep(undefined, undefined, 'searchList', '1');
      this.searchList[1].searchValue = undefined;
    },
    getflOptions (pageNum, search, item) {
      return this.communitySelectByStep(pageNum, search, undefined, 4, item.communityId, item.areas);
    },
    getOptions (pageNum, search) {
      return this.communitySelectByStep(pageNum, search, 'searchList', '1');
    },
    closeModel () {
      this.formList[4].options = [];
      this.formList[4].searchValue = undefined;
      this.$refs.form.form.setFieldsValue({areas: ''});
      this.areaIndex = 1;
      this.visible = false;
    },
    addLeader () {
      this.formList[4].options = [];
      this.formList[4].searchValue = undefined;
      this.areaIndex = 1;
      this.$refs.form.handleSubmit();
    },
    transferValue (val) {
      this.$refs.form.form.setFieldsValue(val);
    },
    regionDisplayRender (labels) {
      this.regionChange(undefined, labels);
    },
    regionChange (val, selected) {
      if (val && selected) {
        this.$refs.form.form.setFieldsValue({communityId: undefined});
        this.formList[4].options = [];

        this.formList[4].areas = undefined;
        this.formList[4].areas = val;
        this.communitySelectByStep(1, undefined, undefined, 4, undefined, val);
        // this.$get({
        //   url: '/community/treeselectByAreas',
        //   params: {
        //     areas: val.toString()
        //   }
        // }).then(res => {
        //   this.formList[4].options = res.data;
        // });
      }
      let isArray = Array.isArray(val);
      if (isArray) { // 判断是change事件还是 displayRender
        this.$refs.location && this.$refs.location.positionChanged();
      }
      if (selected && selected.length > 1) {
        let isCity = this.$store.state.citys.some(el => {
          return el === (isArray ? selected[0].label : selected[0]);
        });
        if (isCity) { // 判断是否为直辖市
          this.position = isArray ? selected[0].label : selected[0];
        } else {
          this.position = isArray ? selected[1].label : selected[1];
        }
      }
      if (val && selected && selected.length > 0) {
        let temp = [];
        selected.forEach(item => {
          let i = item.level - 1;
          temp[i] = item.value;
        });
        for (let i = 0; i < 3; i++) {
          if (temp[i] == undefined) {
            temp[i] = 0;
          }
        }
        this.newAreas = temp.toString();
      }
    },
    changeStatus (row) {
      let status = row.status == 0 ? 1 : 0;
      this.$put({
        url: `/housekeep/post/changeStatus/${row.postId}`,
        params: {
          status
        }
      }).then(({data}) => {
        this.$message.success('设置成功');
        this.$refs.table.getTableList();
      });
    },
    getSelect () {
      this.communitySelectByStep(1, undefined, 'searchList', '1');
      // this.$get({
      //   url: '/community/treeselectByAreas'
      // }).then(res => {
      //   this.recursionList(res.data);
      //   this.searchList[1].options = res.data;
      // });
    },
    recursionList (list) {
      list.forEach(item => {
        item.title = item.label;
        item.key = item.value;
        if (item.children && item.children.length) {
          this.recursionList(item.children);
        }
      });
    },
    /* 打开弹窗 */
    openModal (row) {
      this.visible = true;
      let title = '';
      if (row.postId) {
        title = '修改';
        let url = `/housekeep/post/${row.postId}`;

        this.formList[4].options = [];
        // this.$get({
        //   url: '/community/treeselectByAreas',
        //   params: {
        //     areas: row.areas
        //   }
        // }).then(res => {
        //   this.formList[4].options = res.data;
        // });

        this.$nextTick(() => {
          this.$refs.form.getDetail(url);
          this.$refs.form.routeQuery = row.postId;
        });
      } else {
        title = '新增';
      }
      this.modalTitle = title;
    },

    // 弹窗表单返回结果
    addResHandle (res) {
      if (res.code !== 200) {
        this.$message.error(res.msg);
      } else {
        this.$message.success(res.msg);
        this.$refs.table.getTableList();
        this.visible = false;
      }
    },
    detailResHandle (res) {
      let areas;
      if (res.areas) {
        areas = res.areas.split(',');
        this.newAreas = areas.toString();
        this.formList[4].areas = undefined;
        this.formList[4].areas = areas;
        areas.forEach((i, index) => {
          if (i == 0) {
            areas.splice(index, 1);
          }
        });
      }
      res.areas = areas;
      res.communityId = res.communityId && res.communityId.split(',') || undefined;

      if (res.communityId) {
        this.formList[4].communityId = res.communityId.toString();
      }

      this.newRegionSelectByIds(1, areas);
      this.lngLat = [res.mapLng, res.mapLat];
      this.formList[4].options;
      let communityId = res.communityId;
      this.communitySelectByStep(1, undefined, undefined, 4, res.communityId && res.communityId.toString() || '', areas);

      return res;
    },
    reqHandle (res) {
      res.areas = this.newAreas;
      res.communityId = res.communityId && res.communityId.toString() || undefined;
      return res;
    },
    resHandle (res) {
      return res.rows;
    },
    searchHandle (selectData) {
      // return selectData;
    }
  }
};
</script>
